import revive_payload_client_4sVQNw7RlN from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import plugin_vue3_YdLad5Mpq3 from "/builds/1tool/kfv-portal-trainer/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/builds/1tool/kfv-portal-trainer/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import fontawesome_7xXmPH2btU from "/builds/1tool/kfv-portal-trainer/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.js";
import switch_locale_path_ssr_5csfIgkrBP from "/builds/1tool/kfv-portal-trainer/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/builds/1tool/kfv-portal-trainer/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/builds/1tool/kfv-portal-trainer/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/builds/1tool/kfv-portal-trainer/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import primevue_plugin_egKpok8Auk from "/builds/1tool/kfv-portal-trainer/.nuxt/primevue-plugin.mjs";
import plugin_client_XxbS7tGyhp from "/builds/1tool/kfv-portal-trainer/node_modules/@primevue/nuxt-module/dist/runtime/plugin.client.js";
import chunk_error_client_VGTGVjBfpU from "/builds/1tool/kfv-portal-trainer/plugins/chunk-error.client.ts";
import matomo_3KCvo3pcD6 from "/builds/1tool/kfv-portal-trainer/plugins/matomo.js";
import sentry_3AyO8nEfhE from "/builds/1tool/kfv-portal-trainer/plugins/sentry.ts";
import chart_plugin_igAE1SIhDQ from "/builds/1tool/kfv-portal-trainer/node_modules/@1tool-suite/shared-ui/runtime/chart.plugin.ts";
import primevue_bWGfyPFTq3 from "/builds/1tool/kfv-portal-trainer/node_modules/@1tool-suite/shared-ui/plugins/primevue.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_immediate_client_xfI97IMoyr,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  fontawesome_7xXmPH2btU,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  primevue_plugin_egKpok8Auk,
  plugin_client_XxbS7tGyhp,
  chunk_error_client_VGTGVjBfpU,
  matomo_3KCvo3pcD6,
  sentry_3AyO8nEfhE,
  chart_plugin_igAE1SIhDQ,
  primevue_bWGfyPFTq3
]